module.exports = __webpack_public_path__ + "img/salud-jovenes.9cc7d9d8.png";